import type { Messaging } from "firebase/messaging";
import { app } from "./app";

let messagingPromise: Promise<Messaging | null> | null = null;

export const getMessagingInstance = async (): Promise<Messaging | null> => {
  if (
    typeof window === "undefined" ||
    typeof navigator === "undefined" ||
    !("serviceWorker" in navigator) ||
    !("PushManager" in window)
  ) {
    console.log("Firebase Messaging n'est pas supporté sur ce navigateur.");
    return null;
  }

  if (!messagingPromise) {
    messagingPromise = (async () => {
      try {
        const { getMessaging } = await import("firebase/messaging");
        return getMessaging(app);
      } catch (error) {
        console.error("Erreur lors du chargement dynamique de Firebase Messaging:", error);
        return null;
      }
    })();
  }

  return messagingPromise;
};
